import * as ActionTypes from "./types";

export function fetchApplications(payload) {
  return {
    type: ActionTypes.FETCH_APPLICATIONS,
    payload,
  };
}

export function storeApplications(payload) {
  return {
    type: ActionTypes.STORE_APPLICATIONS,
    payload,
  };
}

export function fetchApplicationsFailed(payload) {
  return {
    type: ActionTypes.FETCH_APPLICATIONS_FAILED,
    payload,
  };
}

export function fetchApplicationsByOrganization(payload) {
  return {
    type: ActionTypes.FETCH_APPLICATIONS_BY_ORGANIZATION,
    payload,
  };
}

export function fetchApplicationsByOrganizationSuccess(payload) {
  return {
    type: ActionTypes.FETCH_APPLICATIONS_BY_ORGANIZATION_SUCCESS,
    payload,
  };
}

export function fetchApplicationsByOrganizationFailed(payload) {
  return {
    type: ActionTypes.FETCH_APPLICATIONS_BY_ORGANIZATION_FAILED,
    payload,
  };
}
